var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('anamnesis',_vm._b({attrs:{"dataCrud2":_vm.localDataCrud},on:{"update:dataCrud2":function($event){_vm.localDataCrud=$event},"update:data-crud2":function($event){_vm.localDataCrud=$event}}},'anamnesis',{
      ..._vm.schema,
      handleEventsCrud: _vm.handleEventsCrud,
      handleEvents: _vm.handleEvents,
      save: _vm.save,
      clickRowInfo: _vm.clickRowInfo,
      remove: _vm.remove,
      snackbar: _vm.snackbar,
      overlay: _vm.overlay,
      overlayMessage: _vm.overlayMessage,
      toggleOverlay: _vm.toggleOverlay,
      status: _vm.status,
    },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }